import React from "react";
import Select from "react-select";
import styled from "styled-components";
import { SectionTitle, SectionWrapper } from "./Components.styles";

const DropdownContainer = styled.div`
  margin-right: 26px;
  min-width: 200px;
  display: block;
  text-align: left;
`;
const Label = styled.span``;

const selectStyles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};

export const DropdownWithLabel = ({ label, options, onChange, value }) => {
  return (
    <DropdownContainer>
      <Label>{label}</Label>
      <Select
        styles={selectStyles}
        options={options}
        value={options.filter((option) => option.value === value)}
        onChange={(option) => {
          // console.log(option)
          onChange(option != null ? option.value : "");
        }}
        isClearable={true}
      />
    </DropdownContainer>
  );
};

export const Section = ({ title, children }) => {
  return (
    <SectionWrapper>
      <SectionTitle>{title}</SectionTitle>
      {children}
    </SectionWrapper>
  );
};
